@if ( thread.type === TYPE.programApplication && (( (thread.reference |
application : { select: ['program'] } | async) ?.program | program : { select:
['cover'] } | async )?.cover | fileUrl : { width: 124, height: 124 } | async);
as src ) {
<img [ngSrc]="src" width="24" height="24" />
} @if ( thread.type === TYPE.organisation && ((thread.reference | organisation :
{ select: ['logo'] } | async)?.logo | fileUrl : { width: 124, height: 124 } |
async); as src ) {
<img [ngSrc]="src" width="24" height="24" />
} @if (thread.type === TYPE.student) {
<un-icon type="user" theme="outline"></un-icon>
}
